var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-sheet',{attrs:{"elevation":"0"}},[_c('v-toolbar',{attrs:{"dense":"","elevation":"0"}},[_c('v-toolbar-title',{staticClass:"checklist"},[_vm._v(" Complete the checklist below ")]),_c('v-spacer')],1),_c('v-divider'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }